export default {"src":"/_next/static/media/orange-loading.1c031dc8.svg","height":97,"width":97,"blurWidth":0,"blurHeight":0};